import { DecimalPipe } from '@angular/common'
import { Directive, HostListener, ElementRef, Renderer2, OnInit, Input } from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'
import { haveValue } from '../utils/functions/form'

@Directive({
  selector: '[appDecimalComma]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NumberCommaDirective,
      multi: true,
    },
    DecimalPipe
  ]
})
export class NumberCommaDirective implements ControlValueAccessor {
  // @Input() isDecimal: any = true
  @Input() isCurrency: boolean = false;
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  private el: HTMLInputElement

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private decimal: DecimalPipe) {
    this.el = this.elementRef.nativeElement
  }

  private formatValue(value: string): string {
    // Kiểm tra nếu giá trị không hợp lệ (chỉ chứa dấu phân cách hoặc không phải số)
    if (!value || isNaN(Number(value))) {
        return value // Giữ nguyên giá trị
      }


    // Chuyển đổi chuỗi thành mảng, chia theo dấu chấm (phần nguyên) và dấu phẩy (phần thập phân)
    const parts: any = value.toString().split('.')
    // Định dạng phần nguyên với DecimalPipe
    parts[0] = this.decimal?.transform(parts[0], '1.0-0', 'en-US')?.replace(/,/g, '.')
    if (parts[1]) {
      if (!this.isCurrency) {
        parts[1] = parts[1].replace(/[^0-9]/g, '') // Làm sạch phần thập phân nếu có
      } else {
        // Giữ nguyên phần thập phân
        parts[1] = parts[1]
      }
    }
    return parts.join(',')
  }

  private parseValue(value: string): any {
    //đưa , thành .
    return this.isCurrency ? value.replace(/\./g, '').replace(',', '.') : parseFloat(value.replace(/\./g, '').replace(',', '.'));
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    // this.el.value = value ? this.formatValue(this.parseValue(value)) : value;
    // this.onTouched();
    // this.onChange(this.parseValue(value));
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (haveValue(value)) {
      const parsedValue = this.parseValue(value)
      // Kiểm tra nếu giá trị không đủ điều kiện format, giữ nguyên
      this.el.value = this.formatValue(parsedValue) // Format hoặc giữ nguyên giá trị
      this.onChange(parsedValue) // Cập nhật giá trị thực tế
    } else {
      this.el.value = '' // Xóa giá trị nếu không hợp lệ
      this.onChange(null)
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value: string) {
    // this.el.value = value ? ${this.parseValue(value)} : value;
    this.el.value = value ? this.formatValue(this.parseValue(value)) : value
  }

  writeValue(value: any): void {
    if (haveValue(value)) {
      this.el.value = this.formatValue(value)
    } else {
      this.el.value = ''
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.el, 'disabled', isDisabled)
  }
}
